const OrderStatus = {
	OPEN: 'OPEN',
	IN_PROGRESS: 'IN_PROGRESS',
	FINISHED: 'FINISHED',
	DECLINED: 'DECLINED'
};

export { OrderStatus };
